module.exports = "/images/ky.svg?7a5a9cd393ffdc01b03e3e911b6b2fbd";